import React, { Component } from "react";

export default class PopupRecuperar extends Component {
    constructor(props) {
        super(props);
    }
    /**
     * 
     */
    componentDidMount() {
        const { clave } = this.props;
        /*lamentablemente necesario para evitar que se cierre el dropdown cuando el usuario hace click sobre el contenido*/
        $(`#${clave} .dropdown-menu`).on({
            "click": function (e) {

                /*si no hay que ejecutar entonces bloqueo la accion*/
                if (e.target.dataset.ejecutar == "true") {
                    /*validar que hacer en caso de ejecutar*/
                } else {
                    e.stopPropagation();
                }
            }
        });
    }
    /**
     * 
     */
    render() {
        const { clave, esBloqueo, funcionesDelUsuario, motivoDescripcion, novedad, recuperarTarjeta, textBoton, mostrarTitle } = this.props;

        let descripcionLeyenda = "";
        let descripcionBoton = "";
        let claseConfirmadorAprobada = "boton-base-confirmador"
        let claseConfirmadorRechazada = "boton-base-confirmador";
        let claseContainerEstado = "clickable container-estado";
        /*si el popup se invoco desde un bloqueo entonces cambio el texto*/
        if (esBloqueo) {
            descripcionBoton = descripcionLeyenda = "Desbloquear";
        } else {
            descripcionBoton = descripcionLeyenda = "Recuperar";
        }

        /*primero que todo, si el usuario tiene permisos sobre la confirmacion*/
        if (funcionesDelUsuario.Confirmacion == true) {
            /*si es una novedad, agregar clases a los componentes segun el estado, confirmada o denegada*/
            if (novedad) {
                claseContainerEstado += " novedad";
                if (esBloqueo) {
                    descripcionLeyenda = "Confirmar, denegar o desbloquear";
                } else {
                    descripcionLeyenda = "Confirmar, denegar o recuperar";
                }

                claseConfirmadorAprobada += ((novedad.NovedadEstadoId == 2) ? " invertido aprobado" : " clickable");
                claseConfirmadorRechazada += ((novedad.NovedadEstadoId == 3) ? " invertido rechazado" : " clickable");
            }
        }

        if (novedad) {
            claseContainerEstado += " novedad";
        } else {
            claseContainerEstado += " sin-novedad";
        }

        return (
            <div className="popup-tarjetas-bloqueo">
                <div className="dropdown" id={clave}>
                    {/*reemplazar por una forma más correcta*/}
                    {(mostrarTitle == undefined || mostrarTitle == true) ?
                        <div className={claseContainerEstado} data-toggle="dropdown" title={motivoDescripcion}>
                            <label className="clickable">{textBoton}</label>
                        </div>
                        : <div className={claseContainerEstado} data-toggle="dropdown">
                            <label className="clickable">{textBoton}</label>
                        </div>
                    }

                    {(novedad && novedad.NovedadEstadoId < 4) &&
                        <ul className="dropdown-menu">
                            <li className="top-popup">
                                <label className="label-primary">{descripcionLeyenda}</label>
                            </li>
                            <li className="bottom-popup">
                                {/*el usuario podria confirmar y denegar una novedad de baja o bloqueo, pero no una que fue aprobada por la administradora*/}
                                {(novedad && funcionesDelUsuario.Confirmacion == true) && <div>
                                    <div className={claseConfirmadorAprobada} onClick={this.props.confirmarNovedad}>
                                        <span className="base-icon icon-confirmado" data-ejecutar="true"></span>
                                    </div>

                                    <div className={claseConfirmadorRechazada} onClick={this.props.denegarNovedad}>
                                        <span className="base-icon icon-denegado" data-ejecutar="true"></span>
                                    </div>
                                </div>}
                                <div className="text-right">
                                    <button type="button" className="btn btn-cta" data-ejecutar="true"
                                        onClick={recuperarTarjeta}>{descripcionBoton}</button>
                                </div>
                            </li>

                        </ul>
                    }
                </div>
            </div>
        );
    }
}